import React, { useState } from 'react';
import Header from '../components/header';
import Footers from '../components/footers';
import { Button, Modal } from 'flowbite-react';
import { AiOutlineLoading } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { serverURL, MonthType, MonthCost, YearType, YearCost } from '../constants';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { usePWAInstall } from 'react-use-pwa-install';

const Profile = () => {
    const install = usePWAInstall();
    const [mName, setName] = useState(sessionStorage.getItem('mName'));
    const [email, setEmail] = useState(sessionStorage.getItem('email'));
    const [password, setPassword] = useState('');
    const [processing, setProcessing] = useState(false);
    const [processingDelete, setProcessingDelete] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [activeTab, setActiveTab] = useState('profile');
    const userType = sessionStorage.getItem('type') || 'free';

    const navigate = useNavigate();

    async function deleteProfile() {
        if (sessionStorage.getItem('adminEmail') === sessionStorage.getItem('email')) {
            toast.error("Admin profile cannot be deleted");
        } else {
            setOpenModal(true);
        }
    }

    async function startDeletion() {
        setProcessingDelete(true);
        try {
            const response = await axios.post(serverURL + '/api/deleteuser', { userId: sessionStorage.getItem('uid') });
            if (response.data.success) {
                toast.success(response.data.message);
                sessionStorage.clear();
                navigate("/signin");
            }
        } catch (error) {
            toast.error('Error deleting profile');
        }
        setProcessingDelete(false);
        setOpenModal(false);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!email || !mName) {
            toast.error('Please fill in all required fields');
            return;
        }
        setProcessing(true);
        try {
            const response = await axios.post(serverURL + '/api/profile', {
                email, mName, password, uid: sessionStorage.getItem('uid')
            });
            if (response.data.success) {
                toast.success(response.data.message);
                sessionStorage.setItem('email', email);
                sessionStorage.setItem('mName', mName);
            }
        } catch (error) {
            toast.error('Error updating profile');
        }
        setProcessing(false);
    };

    const getPlanDisplay = () => {
        if (userType === 'forever') return { name: 'Lifetime', price: 'Free', badge: 'bg-black text-white' };
        if (userType === MonthType) return { name: 'Monthly', price: `$${MonthCost}/mo`, badge: 'bg-black text-white' };
        if (userType === YearType) return { name: 'Yearly', price: `$${YearCost}/yr`, badge: 'bg-black text-white' };
        return { name: 'Free', price: '$0', badge: 'border border-black text-black' };
    };
    const plan = getPlanDisplay();

    const Tab = ({ id, label }) => (
        <button
            onClick={() => setActiveTab(id)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${activeTab === id ? 'border-black text-black' : 'border-transparent text-gray-400 hover:text-gray-600'}`}
        >
            {label}
        </button>
    );

    return (
        <div className='min-h-screen flex flex-col bg-white dark:bg-black'>
            <Header isHome={true} className="sticky top-0 z-50" />
            <div className='flex-1'>
                <div className='max-w-2xl mx-auto px-4 py-8'>
                    {/* Header */}
                    <div className='flex items-center gap-4 mb-8'>
                        <div className='w-16 h-16 bg-black dark:bg-white text-white dark:text-black rounded-full flex items-center justify-center text-2xl font-black'>
                            {(mName || 'U').charAt(0).toUpperCase()}
                        </div>
                        <div>
                            <h1 className='text-2xl font-black dark:text-white'>{mName}</h1>
                            <p className='text-gray-500 text-sm'>{email}</p>
                        </div>
                        <span className={`ml-auto px-3 py-1 rounded-full text-xs font-bold ${plan.badge}`}>{plan.name}</span>
                    </div>

                    {/* Tabs */}
                    <div className='flex border-b border-gray-200 dark:border-gray-800 mb-6'>
                        <Tab id="profile" label="Profile" />
                        <Tab id="subscription" label="Subscription" />
                        <Tab id="settings" label="Settings" />
                    </div>

                    {/* Profile Tab */}
                    {activeTab === 'profile' && (
                        <form onSubmit={handleSubmit}>
                            <div className='space-y-5'>
                                <div>
                                    <label className='text-sm font-bold text-black dark:text-white block mb-1.5'>Name</label>
                                    <input value={mName} onChange={(e) => setName(e.target.value)}
                                        className='border border-gray-300 dark:border-gray-700 dark:bg-black dark:text-white rounded-lg w-full px-3 py-2.5 text-sm focus:ring-black focus:border-black' type="text" />
                                </div>
                                <div>
                                    <label className='text-sm font-bold text-black dark:text-white block mb-1.5'>Email</label>
                                    <input value={email} onChange={(e) => setEmail(e.target.value)}
                                        className='border border-gray-300 dark:border-gray-700 dark:bg-black dark:text-white rounded-lg w-full px-3 py-2.5 text-sm focus:ring-black focus:border-black' type="email" />
                                </div>
                                <div>
                                    <label className='text-sm font-bold text-black dark:text-white block mb-1.5'>New Password</label>
                                    <input value={password} onChange={(e) => setPassword(e.target.value)}
                                        className='border border-gray-300 dark:border-gray-700 dark:bg-black dark:text-white rounded-lg w-full px-3 py-2.5 text-sm focus:ring-black focus:border-black' type="password" placeholder='Leave empty to keep current' />
                                </div>
                                <button type="submit" disabled={processing}
                                    className='w-full bg-black dark:bg-white text-white dark:text-black font-bold py-3 rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50'>
                                    {processing ? 'Saving...' : 'Save Changes'}
                                </button>
                            </div>
                        </form>
                    )}

                    {/* Subscription Tab */}
                    {activeTab === 'subscription' && (
                        <div className='space-y-5'>
                            {/* Current Plan */}
                            <div className='border border-gray-200 dark:border-gray-800 rounded-lg p-5'>
                                <div className='flex items-center justify-between mb-4'>
                                    <div>
                                        <p className='text-xs text-gray-400 uppercase font-bold'>Current Plan</p>
                                        <p className='text-xl font-black dark:text-white'>{plan.name} Plan</p>
                                    </div>
                                    <p className='text-2xl font-black dark:text-white'>{plan.price}</p>
                                </div>

                                {userType === 'free' ? (
                                    <div>
                                        <p className='text-sm text-gray-500 mb-4'>Upgrade to unlock all features including unlimited sub-topics, AI chat, and certificates.</p>
                                        <button onClick={() => navigate('/pricing', { state: { header: true } })}
                                            className='w-full bg-black dark:bg-white text-white dark:text-black font-bold py-3 rounded-lg hover:opacity-90'>
                                            Upgrade Plan
                                        </button>
                                    </div>
                                ) : userType !== 'forever' ? (
                                    <div className='flex gap-3'>
                                        <button onClick={() => navigate('/pricing', { state: { header: true } })}
                                            className='flex-1 border border-black dark:border-white text-black dark:text-white font-bold py-2.5 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 text-sm'>
                                            Change Plan
                                        </button>
                                        <button onClick={() => navigate('/subscription')}
                                            className='flex-1 border border-gray-300 text-gray-500 font-bold py-2.5 rounded-lg hover:bg-gray-50 text-sm'>
                                            Manage / Cancel
                                        </button>
                                    </div>
                                ) : (
                                    <p className='text-sm text-gray-500'>You have lifetime access to all features.</p>
                                )}
                            </div>

                            {/* Features */}
                            <div className='border border-gray-200 dark:border-gray-800 rounded-lg p-5'>
                                <p className='text-xs text-gray-400 uppercase font-bold mb-3'>Your Features</p>
                                <div className='space-y-2'>
                                    {[
                                        { name: `Generate ${userType === 'free' ? '5' : '10'} Sub-Topics`, available: true },
                                        { name: 'Create Unlimited Courses', available: true },
                                        { name: 'Video & Theory Course', available: userType !== 'free' },
                                        { name: 'Theory & Image Course', available: true },
                                        { name: 'Course In 23+ Languages', available: userType !== 'free' },
                                        { name: 'AI Teacher Chat', available: userType !== 'free' },
                                        { name: 'Download Certificates', available: userType !== 'free' },
                                    ].map((feature, i) => (
                                        <div key={i} className={`flex items-center gap-2 text-sm ${feature.available ? 'text-black dark:text-white' : 'text-gray-300 dark:text-gray-700 line-through'}`}>
                                            <span className={`text-xs ${feature.available ? 'text-green-600' : 'text-gray-300'}`}>{feature.available ? '✓' : '✗'}</span>
                                            {feature.name}
                                        </div>
                                    ))}
                                </div>
                                {userType === 'free' && (
                                    <button onClick={() => navigate('/pricing', { state: { header: true } })}
                                        className='mt-4 text-sm font-bold text-black dark:text-white underline'>
                                        Upgrade to unlock all features →
                                    </button>
                                )}
                            </div>

                            {/* Billing History */}
                            <div className='border border-gray-200 dark:border-gray-800 rounded-lg p-5'>
                                <p className='text-xs text-gray-400 uppercase font-bold mb-3'>Billing</p>
                                {userType === 'free' ? (
                                    <p className='text-sm text-gray-400'>No billing history — you're on the free plan.</p>
                                ) : (
                                    <div>
                                        <div className='flex items-center justify-between py-2 border-b border-gray-100 dark:border-gray-800'>
                                            <div>
                                                <p className='text-sm font-medium dark:text-white'>{plan.name} Plan</p>
                                                <p className='text-xs text-gray-400'>Active subscription</p>
                                            </div>
                                            <div className='text-right'>
                                                <p className='text-sm font-bold dark:text-white'>{plan.price}</p>
                                                <span className='text-xs bg-green-50 text-green-700 px-2 py-0.5 rounded-full'>Active</span>
                                            </div>
                                        </div>
                                        <button onClick={() => navigate('/subscription')}
                                            className='mt-3 text-sm font-bold text-black dark:text-white underline'>
                                            View subscription details →
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Settings Tab */}
                    {activeTab === 'settings' && (
                        <div className='space-y-5'>
                            {install && (
                                <div className='border border-gray-200 dark:border-gray-800 rounded-lg p-5'>
                                    <p className='text-sm font-bold dark:text-white mb-1'>Desktop App</p>
                                    <p className='text-xs text-gray-400 mb-3'>Install Coursea as a desktop application for quick access.</p>
                                    <button onClick={install}
                                        className='border border-black dark:border-white text-black dark:text-white font-bold py-2 px-4 rounded-lg text-sm hover:bg-gray-50 dark:hover:bg-gray-900'>
                                        Install App
                                    </button>
                                </div>
                            )}

                            <div className='border border-red-100 dark:border-red-900 rounded-lg p-5'>
                                <p className='text-sm font-bold text-red-600 mb-1'>Danger Zone</p>
                                <p className='text-xs text-gray-400 mb-3'>Permanently delete your account and all your courses. This action cannot be undone.</p>
                                <button onClick={deleteProfile}
                                    className='bg-red-600 text-white font-bold py-2 px-4 rounded-lg text-sm hover:bg-red-700'>
                                    Delete Account
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Modal show={openModal} size="md" onClose={() => setOpenModal(false)} popup>
                <Modal.Body className='bg-white dark:bg-black pt-4'>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-red-600" />
                        <h3 className="mb-5 text-lg font-bold text-black dark:text-white">Delete your account?</h3>
                        <p className='text-sm text-gray-500 mb-5'>All your courses, data, and subscription will be permanently deleted.</p>
                        <div className="flex justify-center gap-3">
                            <Button isProcessing={processingDelete} processingSpinner={<AiOutlineLoading className="h-6 w-6 animate-spin" />}
                                className='rounded-lg' color="failure" onClick={startDeletion}>Yes, delete</Button>
                            <Button className='rounded-lg dark:text-white' color="gray" onClick={() => setOpenModal(false)}>Cancel</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Footers className="sticky bottom-0 z-50" />
        </div>
    );
};

export default Profile;
